// extracted by mini-css-extract-plugin
export default {"root":"esdydUs1","dot":"TUSiLENF","dots":"Zft9rPYc","doubled":"UJzP4d9r","dots-doubled":"vpZtb2OQ","dotsDoubled":"vpZtb2OQ"};